import { render } from "./write.vue?vue&type=template&id=5a2bd436&scoped=true&ts=true"
import script from "./write.vue?vue&type=script&lang=ts&config=true"
export * from "./write.vue?vue&type=script&lang=ts&config=true"

import "./write.vue?vue&type=style&index=0&id=5a2bd436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2bd436"]])

export default __exports__